
    var riot = require('riot')
    import { Product } from './gb-product';
riot.tag2('gb-product', '<yield> <gb-product-image></gb-product-image> <gb-product-info></gb-product-info> <gb-variant-switcher></gb-variant-switcher> </yield>', 'gb-product.gb-infinite,[data-is="gb-product"].gb-infinite{ position: absolute; opacity: 1; } gb-product.gb-infinite.tombstone.invisible,[data-is="gb-product"].gb-infinite.tombstone.invisible{ opacity: 0; }', '', function(opts) {
    this._mixin(Product);
});

    
  


// WEBPACK FOOTER //
// ./src/tags/product/gb-product.tag.html